module.exports = __webpack_public_path__ + "front/img/0.b74f6c15.jpg";